/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { selectFileFromSource, isMobileApplication, checkAndRequestFilePermissions } from '../../../utilities/MobileUtil';
import { PermissionsRequiredModal, requiredPermissionTypes } from '../modal/WarningModal';
import { actions as systemModalActions } from '../../redux/ducks/systemModal';

const FilePickerButton = (props) => {
  const { dispatch, sourceType, onChange, children, style, onError, intl } = props;
  const accept = props.accept || '*';

  const labelRef = React.useRef(null);

  function checkPermission() {
    if (isMobileApplication()) {
      checkAndRequestFilePermissions(
        () => {
          selectFileFromSource(
            intl.formatMessage({ id: 'ui-data.fileName.untitled.text' }),
            sourceType,
            () => {
              if (onError) { onError(); }
            },
            imgBlob => {
              onChange(imgBlob);
            },
          );
        },
        () => {},
        () => {
          dispatch(systemModalActions.push(<PermissionsRequiredModal permissions={[requiredPermissionTypes.library]} />));
        },
      );
    } else {
      labelRef.current.click();
    }
  }

  function handleChange(e) {
    const fileData = e.target.files[0];
    onChange(fileData);
    e.value = null;
  }

  return isMobileApplication() ? (
    <button
      className="cmp-filepicker-button profile-background-color"
      onClick={checkPermission}
      style={style}
    >
      {children}
    </button>
  ) : (
    <div className="cmp-filepicker-button" style={props.style}>
      <label
        className="profile-background-color"
        htmlFor="cmp-filepicker-button"
        ref={labelRef}
      >
        <div className="cmp-filepicker-button-contents">
          {children}
        </div>
        <input
          id="cmp-filepicker-button"
          type="file"
          accept={accept}
          onChange={handleChange}
        />
      </label>
    </div>
  );
}
FilePickerButton.propTypes = {
  name: PropTypes.string,
  children: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func,
  accept: PropTypes.string,
  dispatch: PropTypes.func,
  style: PropTypes.any,
  sourceType: PropTypes.any,
  intl: PropTypes.any,
};

export default connect()(injectIntl(FilePickerButton));
